<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-registration-email">
      <p class="title title-double-line">新規接続申請<span class="mini">-&nbsp;接続申請書&nbsp;-</span></p>
      <div class="content content-center">
        <p>アキバトリカルへメールアドレスを使用して登録します。</p>
        <p><router-link :to="{name: 'terms'}">利用規約</router-link>及び<router-link :to="{name : 'privacy'}">プライバシーポリシー</router-link>に同意の上、以下のフォームに必要事項を入力してください。</p>
      </div>

      <PaFrontForm
        :action="'/'"
        :formSet="formSet"
        :submitText="'新規申請'"
        :submitLoading="submitLoading"
        
        @handleSubmit="handleSubmit"
        class="pa-front-form-border-top"
      >
        <template v-slot:additional-footer>
          <div class="agreement-confirmation">
            <div class="description">
              <p>以下の項目を同意頂ける場合はチェックしてください。</p>
            </div>

            <div v-for="(agreement, index) in agreements" :key="index" class="agreement-set">
              <input type="checkbox" :name="index" :id="index" value="yes" v-model="agreement.value" :disabled="agreement.isDisabled" />
              <label :for="index">{{agreement.label}}</label>
            </div>

            <transition name="validation-fail">
              <p v-if="(agreementAcception === false)"><span class="valid-error valid-wide">上記の項目を全て同意いただけない場合はご参加いただけません。</span></p>
            </transition>
          </div>
        </template>
      </PaFrontForm>
    </div>
  </section>
</template>

<script>
import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins,
    FormValidationControlMixin
  ],

  components : {
    PaFrontForm
  },

  data : function(){
    return {
      submitLoading : false,

      formSet       : {
        name                  : {
          name            : 'name',
          label           : 'ユーザーID',
          description     : ' \
            <p>アキバトリカル内で使用する半角英数字のIDです。半角英数字とアンダーバー（_）、ハイフン（-）を使用できます。最初の一文字目は英字のみ指定可能です。数字と記号は二文字目から使用可能です。</p> \
            <p>他の人が使用している場合、同じIDは登録できません。登録したIDは後から変更できません。</p> \
          ',
          validationRules : ['notEmpty', 'alphanumericId', 'firstAlpha', 'max'],
        },

        displayname           : {
          name            : 'displayname',
          label           : '名前',
          description     : ' \
            <p>アキバトリカル内で使用する名前です。日本語が使用できます。後から変更できます。</p> \
          ',
          validationRules : ['notEmpty', 'max'],
        },

        email                 : {
          name            : 'email',
          label           : 'メールアドレス',
          description     : ' \
            <p>アキバトリカルへ登録するメールアドレスです。ログイン時にログイン用のIDとして使用します。</p> \
          ',
          validationRules : ['notEmpty', 'email', 'max'],
        },

        password              : {
          name            : 'password',
          label           : 'パスワード',
          description     : ' \
            <p>ログイン時に使用するパスワードです。半角英数字記号8文字以上で指定してください。</p>  \
          ',
          validationRules : ['notEmpty', 'max', 'password'],
          inputType       : 'password',
        },

        password_confirmation : {
          name            : 'password_confirmation',
          label           : 'パスワード再入力',
          description     : ' \
            <p>確認のため、パスワードフィールドに入力したパスワードと同じものを再入力してください。</p>  \
          ',
          validationRules : ['notEmpty', 'max', 'password', 'passwordConfirmation'],
          inputType       : 'password',
        }
      },

      agreements : {
        agreement1 : {
          label       : '私は利用規約とプライバシーポリシーを確認し、記載内容に同意します。',
          value       : false,
          isDisabled  : false,
        },

        agreement2 : {
          label       : '私は運営者の判断により、不適切なアカウントと判断された場合、アカウントが予告なく利用停止になることを同意し、一切の異議を申し立てない事を同意します。',
          value       : false,
          isDisabled  : false,
        },

        agreement3 : {
          label       : 'アキバトリカルを楽しく利用し、他のユーザーに迷惑となる行動を行わないことを誓います。',
          value       : false,
          isDisabled  : false,
        },
      },

      agreementAcception  : null
    };
  },

  methods : {
    agreementsValidation(){
      if(
        (this.agreements.agreement1.value === true) && 
        (this.agreements.agreement2.value === true) && 
        (this.agreements.agreement3.value === true)
      ){
        this.agreementAcception = true;
      }else{
        this.agreementAcception = false;
      }
    },

    async handleSubmit(){
      this.agreementsValidation();

      this.submitLoading = true;

      if( this.checkFormPreValidation() && (this.agreementAcception === true) ){
        this.disabledFields();

        const results = await this.$store.dispatch({
          type                  : 'requests/registration/registrationWithEmail',
          email                 : this.formSet['email']['value'],
          name                  : this.formSet['name']['value'],
          displayname           : this.formSet['displayname']['value'],
          password              : this.formSet['password']['value'],
          password_confirmation : this.formSet['password_confirmation']['value'],
        });

        const validationResult = await this.RESTResultResultValidationGuard(results, [], [200, 422]);

        this.submitLoading = false;
        this.unDisabledFields();

        if(validationResult === true){
          switch(results.status){
            case 200:
              this.$router.push({name: 'home'});
            break;
            
            case 422:
              for(let errorField in results.data.errors){
                if(results.data.errors[errorField][0] !== undefined){
                  for(let i in this.formSet){
                    if(this.formSet[i]['name'] === errorField){
                      this.formSet[i]['isUnvalid']    = true;
                      this.formSet[i]['unvalidMessage'] = results.data.errors[errorField][0];
                    }
                  }
                }
              }

              this.fireInputErrorFlashMessage();
            break;
          }
        }

        return;
      }else{
        this.submitLoading = false;
        this.unDisabledFields();
        
        this.fireInputErrorFlashMessage();
      }
    },

    fireInputErrorFlashMessage(){
      this.flashMessageToScroll({
        status    : 'error',
        text      : '&nbsp;入力項目にエラーが存在します。今一度ご確認ください。',
        autoClose : 1800,
        cancelBtn : true,
      });
    }
  },

  async mounted(){
    await this.initializePage();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-registration{
    .pa-registration-email{
      .agreement-confirmation{
        border-top:.2rem solid #D8C19C;
        width:95%;
        margin:.8rem auto 0;
        padding:.4rem 0 0;

        .agreement-set{
          margin-bottom:.4rem;
        }

        label{
          margin-left:.4rem;
        }

        div.description{
          width:100%;
          font-size: 1rem;
          margin:0 0 .4rem;
          font-weight: bold;
          text-align: center;
          border-bottom:.1rem solid #D8CAB1;
        }
      }
    }
  }
}
</style>